import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../widgets/layout/CardUI'
import BadgeUI from '../../../widgets/output/BadgeUI'
import WaivePrepaymentFeeModalSF from './WaivePrepaymentFeeModalSF'

const PrepaymentFeeUI = ({ loan, context, onRefreshClick,
  prepaymentFeeWaived, onWaivePrepaymentFeeSubmitClick, onWaivePrepaymentFeeCancelClick
}) =>
  <CardUI className='g_m_bottom_100' title='Prepayment fee'>
    <span className='g_flex_h'>
      <Link to='#' onClick={onWaivePrepaymentFeeSubmitClick}>
        Waive prepayment fee
      </Link>
      <BadgeUI label={loan.waivePrepaymentFee ? 'waived' : 'not waived'} />
    </span>

    <WaivePrepaymentFeeModalSF
      context={context} loan={loan}
      onRefreshClick={onRefreshClick}
      onCancelClick={onWaivePrepaymentFeeCancelClick}
      updateMode={prepaymentFeeWaived}
    />
  </CardUI>

export default PrepaymentFeeUI
